import { useParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import ContactPosts from '../components/ContactPosts';
import RelatedArticles from '../components/RelatedArticles';
import ArticleNotFound from '../components/ArticleNotFound';
import './ArticleDetail.css';

// 🔥 NUEVA FUNCIÓN para encontrar la categoría MÁS ESPECÍFICA en el menú
const findMostSpecificCategoryInMenu = (categorySlugs, menu = menuData) => {
  // Buscar en orden: subsubcategorías -> subcategorías -> categorías principales
  for (const slug of categorySlugs) {
    for (const item of menu) {
      // Buscar en subsubcategorías primero (más específico)
      if (item.subcategories) {
        for (const subitem of item.subcategories) {
          if (subitem.subsubcategories) {
            for (const subsubitem of subitem.subsubcategories) {
              if (subsubitem.slug === slug) {
                return {
                  category: item.path,
                  subcategory: subitem.path,
                  subsubcategory: subsubitem.path,
                  mainCategory: item.path,
                };
              }
            }
          }
        }
      }
    }
  }

  // Si no encontró subsubcategorías, buscar subcategorías
  for (const slug of categorySlugs) {
    for (const item of menu) {
      if (item.subcategories) {
        for (const subitem of item.subcategories) {
          if (subitem.slug === slug) {
            return {
              category: item.path,
              subcategory: subitem.path,
              subsubcategory: '',
              mainCategory: item.path,
            };
          }
        }
      }
    }
  }

  // Si no encontró subcategorías, buscar categorías principales
  for (const slug of categorySlugs) {
    for (const item of menu) {
      if (item.slug === slug) {
        return {
          category: item.path,
          subcategory: '',
          subsubcategory: '',
          mainCategory: item.path,
        };
      }
    }
  }
  return null;
};

// 🔥 FUNCIÓN MEJORADA para extraer todos los slugs con su jerarquía completa
const getAllCategorySlugs = (categories) => {
  const slugs = [];

  const extractSlugs = (categoryList) => {
    categoryList.forEach((category) => {
      slugs.push(category.slug);
      if (category.children && category.children.length > 0) {
        extractSlugs(category.children);
      }
    });
  };

  extractSlugs(categories);
  return slugs;
};

const menuData = [
  {
    name: 'INICIO',
    path: 'inicio',
    slug: 'inicio',
    url: '/',
  },
  {
    name: 'EMPAQUE Y LOGÍSTICA',
    path: 'empaque-logistica',
    slug: 'empaque-y-logistica',
    url: '/category/empaque-y-logistica',
    subcategories: [
      {
        name: 'Almacenamiento, Manejo de Cargas y Seguridad Logística',
        path: 'almacenamiento',
        slug: 'almacenamiento-manejo-de-cargas-y-seguridad-logistica',
        url: '/category/almacenamiento-manejo-de-cargas-y-seguridad-logistica',
      },
      {
        name: 'Cajas, Protección y Embalaje de Cartón',
        path: 'cajas',
        slug: 'cajas-proteccion-y-embalaje-de-carton',
        url: '/category/cajas-proteccion-y-embalaje-de-carton',
      },
      {
        name: 'Cintas y Adhesivos',
        path: 'cintas',
        slug: 'cintas-y-adhesivos',
        url: '/category/cintas-y-adhesivos',
      },
      {
        name: 'Embalaje y Unitización de Cargas',
        path: 'embalaje',
        slug: 'embalaje-y-unitizacion-de-cargas',
        url: '/category/embalaje-y-unitizacion-de-cargas',
        subsubcategories: [
          {
            name: 'Fleje',
            path: 'fleje',
            slug: 'fleje',
            url: '/category/fleje',
          },
          {
            name: 'Película Stretch',
            path: 'stretch',
            slug: 'pelicula-stretch',
            url: '/category/pelicula-stretch',
          },
          {
            name: 'Película Termoencogible',
            path: 'termoencogible',
            slug: 'pelicula-termoencogible',
            url: '/category/pelicula-termoencogible',
          },
          {
            name: 'Rafia',
            path: 'rafia',
            slug: 'rafia',
            url: '/category/rafia',
          },
          {
            name: 'Stretch Hood',
            path: 'stretch-hood',
            slug: 'stretch-hood',
            url: '/category/stretch-hood',
          },
        ],
      },
      {
        name: 'Empaque Protector, Relleno y Comercio Electrónico',
        path: 'empaque-protector',
        slug: 'empaque-protector-relleno-y-comercio-electronico',
        url: '/category/empaque-protector-relleno-y-comercio-electronico',
      },
      {
        name: 'Maquinaria',
        path: 'maquinaria',
        slug: 'maquinaria',
        url: '/category/maquinaria',
      },
    ],
  },
  {
    name: 'SUMINISTROS INSTITUCIONALES',
    path: 'suministros',
    slug: 'suministros-institucionales',
    url: '/category/suministros-institucionales',
    subcategories: [
      {
        name: 'Equipo de Protección Personal',
        path: 'proteccion',
        slug: 'equipo-de-proteccion-personal',
        url: '/category/equipo-de-proteccion-personal',
      },
      {
        name: 'Higiene y Limpieza',
        path: 'higiene',
        slug: 'higiene-y-limpieza',
        url: '/category/higiene-y-limpieza',
      },
      {
        name: 'Soluciones para Food Service',
        path: 'food-service',
        slug: 'soluciones-para-food-service',
        url: '/category/soluciones-para-food-service',
      },
    ],
  },
  {
    name: 'GLOSARIO Y FORMACIÓN',
    path: 'glosario',
    slug: 'glosario-y-formacion',
    url: '/category/glosario-y-formacion',
    subcategories: [
      {
        name: 'Definiciones',
        path: 'definiciones',
        slug: 'definiciones',
        url: '/category/definiciones',
      },
      {
        name: 'Historia',
        path: 'historia',
        slug: 'historia',
        url: '/category/historia',
      },
      {
        name: 'Materiales',
        path: 'materiales',
        slug: 'materiales',
        url: '/category/materiales',
      },
    ],
  },
  {
    name: 'TIENDA PACKSYS',
    path: 'tienda',
    url: 'https://packsys.com/',
  },
];

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notFound, setNotFound] = useState(false);

  const viewRegistered = useRef(false);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;

    const abortController = new AbortController();

    const fetchArticle = async () => {
      try {
        setLoading(true);
        setError(null);
        setNotFound(false);

        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/articles/${slug}`,
          {
            signal: abortController.signal,
          }
        );

        if (!res.ok) {
          if (res.status === 404) {
            setNotFound(true); // 🔥 Artículo no encontrado
          } else {
            throw new Error('No se pudo cargar el artículo');
          }
          return;
        }
        const data = await res.json();

        if (isMounted.current) {
          setArticle(data);

          // 🔥 NUEVO: Procesar categorías del artículo para encontrar la MÁS ESPECÍFICA
          if (data.categories && data.categories.length > 0) {
            // Obtener todos los slugs de categorías
            const allSlugs = getAllCategorySlugs(data.categories);

            // Buscar la categoría MÁS ESPECÍFICA que exista en el menú
            const foundCategory = findMostSpecificCategoryInMenu(allSlugs);

            if (foundCategory) {
              // Disparar evento para actualizar navbar y footer
              const event = new CustomEvent('articleCategoryLoaded', {
                detail: foundCategory,
              });
              window.dispatchEvent(event);

              // Guardar en localStorage para persistencia
              localStorage.setItem(
                'lastActiveCategory',
                JSON.stringify(foundCategory)
              );
            } else {
              // Limpiar selección
              const clearEvent = new CustomEvent('articleCategoryLoaded', {
                detail: {
                  category: '',
                  subcategory: '',
                  subsubcategory: '',
                  mainCategory: '',
                },
              });
              window.dispatchEvent(clearEvent);
            }
          } else {
            // Limpiar selección si no hay categorías
            const clearEvent = new CustomEvent('articleCategoryLoaded', {
              detail: {
                category: '',
                subcategory: '',
                subsubcategory: '',
                mainCategory: '',
              },
            });
            window.dispatchEvent(clearEvent);
          }

          // Registrar vista
          if (data.id && !viewRegistered.current) {
            viewRegistered.current = true;
            try {
              await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/article_views/`,
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ article_id: data.id }),
                }
              );
            } catch (viewError) {
              console.error('Error al registrar visualización:', viewError);
            }
          }
        }
      } catch (err) {
        if (err.name !== 'AbortError' && isMounted.current) {
          console.error('Error:', err);
          setError(err.message);
        }
      } finally {
        if (isMounted.current && !abortController.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchArticle();

    return () => {
      isMounted.current = false;
      abortController.abort();
    };
  }, [slug]);

  // Resto del código permanece igual...
  if (notFound) {
    return <ArticleNotFound />;
  }
  if (loading)
    return (
      <div className="loading-container">
        <p>Cargando artículo...</p>
      </div>
    );
  if (error)
    return (
      <div className="error-container">
        <p>Error: {error}</p>
      </div>
    );
  if (!article)
    return (
      <div className="not-found-container">
        <p>Artículo no encontrado.</p>
      </div>
    );
  if (!article) {
    return <ArticleNotFound />;
  }

  const backgroundImage = article.featured_image_url;

  return (
    <div className="article-detail">
      {/* Sección superior con imagen de fondo */}
      <section
        className="article-header"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="header-overlay">
          <div className="header-content">
            <h1 className="article-title">{article.title}</h1>
            <div className="article-meta">
              <span className="author">
                Por {article.author?.display_name || 'Anónimo'}
              </span>
              <span className="separator">—</span>
              <span className="date">
                {new Date(article.published_at).toLocaleDateString('es-MX', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })}
              </span>
            </div>
            {article.categories && article.categories.length > 0 && (
              <div className="categories">
                {article.categories
                  .flatMap((cat) =>
                    (function flattenLeaves(category) {
                      if (category.children && category.children.length > 0) {
                        return category.children.flatMap(flattenLeaves);
                      }
                      return [category];
                    })(cat)
                  )
                  .map((category) => (
                    <a
                      href={'/category/' + category.slug}
                      key={category.id}
                      className="category-tag"
                    >
                      {category.name}
                    </a>
                  ))}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contenido del artículo */}
      <section className="article-content">
        <div
          className="content-html"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </section>

      {/* Contenido de contacto */}
      <ContactPosts />

      {/* Sección de comentarios */}
      <section className="comments-section">
        <h3>Comentarios</h3>
        {article.comments && article.comments.length > 0 ? (
          <div className="comments-list">
            {article.comments.map((comment) => (
              <div key={comment.id} className="comment-card">
                <div className="comment-header">
                  <strong className="comment-author">
                    {comment.author_name ||
                      comment.user?.display_name ||
                      'Anónimo'}
                  </strong>
                  <span className="comment-date">
                    {comment.created_at &&
                      new Date(comment.created_at).toLocaleDateString('es-MX')}
                  </span>
                </div>
                <p className="comment-content">{comment.content}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-comments">No hay comentarios aún.</p>
        )}
      </section>
      <RelatedArticles currentArticleSlug={slug} />
    </div>
  );
}
